import {useEffect} from 'react'

import {useCurrentBasket} from '@epmc-mach/accelarator/overrides/app/hooks/use-current-basket'

import {legacyNavigator} from '/overrides/app/utils/navigator'

export const useEmptyBasketCartRedirect = () => {
    const {
        data: basket,
        isLoading,
        isFetching,
        isRefetching,
        isMergingInProgress
    } = useCurrentBasket()

    const {productItems = [], orderTotal = 0, productTotal = 0} = basket ?? {}
    const isBasketEmpty = productItems.length === 0 && orderTotal === 0 && productTotal === 0

    useEffect(() => {
        if (!isLoading && !isFetching && !isRefetching && !isMergingInProgress && isBasketEmpty) {
            legacyNavigator.navigateToCartPage()
        }
    }, [isLoading, isFetching, isRefetching, isMergingInProgress, isBasketEmpty])
}
